import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { TegelModule } from '@scania/tegel-angular-17';
import { LoadingService } from '../../core/services/application/util/loading/loading.service';

@Component({
  selector: 'app-spinner',
  imports: [CommonModule, TegelModule],
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss'
})
export class SpinnerComponent {
  readonly loadingService = inject(LoadingService);
}
